import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Input from '../../../components/forms/Input'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import moment from 'moment'
import i18n from 'simple-react-i18n'
import { getExecStatusIcon, getJobStatus } from '../../../utils/JobUtils'
import Button from '../../../components/forms/Button'
import RadioButtons from '../../../components/forms/RadioButtons'
import AppStore from '../../../store/AppStore'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import MultiContributorsAutocomplete
    from '../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import { arrayOf } from '../../../utils/StoreUtils'
import ContributorDto from '../../../referencial/components/contributor/dto/ContributorDto'
import { Grid } from '@mui/material'
import { IMPORT_FORMATS } from '../../constants/JobFormat'
import Select from '../../../components/forms/Select'

class JobTableExecutionsForm extends Component {
    constructor(props) {
        super(props)
        this.state = AppStore.getState().JobReducer.jobTableCache?.filters || {
            searchValue: undefined,
            startDate: null,
            scheduled: undefined,
            status: [],
            endDate: null,
            file: undefined,
            displayMode: 'job',
        }
    }

    onChangeFilter(filterName, value, cb) {
        this.setState({ ...this.state, [filterName]: value }, cb)
    }

    submit = () => {
        this.props.onSubmit({
            ...this.state,
            scheduled: this.state.scheduled && (this.state.scheduled === 1 || !(this.state.scheduled === 2)),
        })
    }

    render() {
        const {
            searchValue,
            file,
            station,
            startDate,
            endDate,
            scheduled,
            status,
            displayMode,
            manager,
            jobType,
        } = this.state
        const statusOptions = getJobStatus().map((s) => {
            const val = parseInt(s.header.replace('statut-', ''), 10)
            return {
                id: val,
                value: val,
                name: s.label,
                label: s.label,
                icon: (
                    <Grid
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            mr: 0.75,
                        }}
                    >
                        {getExecStatusIcon({ status: val }, 18, null)}
                    </Grid>
                ),
            }
        })
        const scheduledOptions = [
            {
                value: 1,
                name: i18n.yes,
            },
            {
                value: 2,
                name: i18n.no,
            },
        ]
        const displayModes = [
            {
                code: 'job',
                name: i18n.job,
            },
            {
                code: 'executions',
                name: i18n.executions,
            },
        ]
        const jobs = AppStore.getState().JobReducer.jobTable.data
        const jobsWithContributors = jobs.filter(job => job.managers && job.managers.length > 0)
        const contributors = this.props.contributors.filter(v =>jobsWithContributors.some(job => job.managers === v.id.toString()))
        return (
            <Grid container columnSpacing={1}>
                <Grid container size={12}>
                    <Grid size={2.5}>
                        <Input
                            title={i18n.search}
                            tooltip={ i18n.searchThenEnter }
                            clearFunction
                            value={searchValue}
                            onChange={(value) => this.onChangeFilter('searchValue', value || undefined)}
                            onEnterKeyPress={(value) => this.onChangeFilter('searchValue', value || undefined, this.submit)}
                        />
                    </Grid>
                    <Grid size={1.75}>
                        <Input
                            title={i18n.fileLabel}
                            clearFunction
                            value={file}
                            onChange={(value) => this.onChangeFilter('file', value || undefined)}
                        />
                    </Grid>
                    <Grid size={1.75}>
                        <Input
                            title={i18n.station}
                            clearFunction
                            value={station}
                            onChange={(value) => this.onChangeFilter('station', value || undefined)}
                        />
                    </Grid>
                    <Grid size={1.5}>
                        <SimpleDatePicker
                            onChange={(value) => this.onChangeFilter('startDate', value)}
                            value={startDate}
                            label={i18n.startDate}
                            max={moment().endOf('day').valueOf()}
                        />
                    </Grid>
                    <Grid size={1.5}>
                        <SimpleDatePicker
                            onChange={(value) => this.onChangeFilter('endDate', value)}
                            label={i18n.endDate}
                            value={endDate}
                            max={moment().endOf('day').valueOf()}
                        />
                    </Grid>
                    <Grid size={2}>
                        <MultiContributorsAutocomplete
                            label={i18n.administrator}
                            disablePortal={false}
                            options={contributors}
                            values={manager}
                            onChange={(value) => this.onChangeFilter('manager', value)}
                        />
                    </Grid>
                    <Grid size={1}>
                        <SuperMultiAutocomplete
                            options={scheduledOptions}
                            onChange={(value) => this.onChangeFilter('scheduled', value)}
                            keyValue='value'
                            label={i18n.scheduled}
                            values={scheduled}
                        />
                    </Grid>
                </Grid>
                <Grid size={4}>
                    <SuperMultiAutocomplete
                        label={i18n.status}
                        options={statusOptions}
                        values={status}
                        onChange={(value) => this.onChangeFilter('status', value || [])}
                        multiple
                        noSort
                        limit={2}
                        disablePortal={false}
                        data-cy='jobStatus'
                    />
                </Grid>
                <Grid size={3} sx={{ alignSelf: 'center' }}>
                    <RadioButtons
                        onChange={(value) => this.onChangeFilter('displayMode', value) }
                        elements={ displayModes }
                        title={i18n.displayMode}
                        selected={displayMode}
                    />
                </Grid>
                <Grid size={3}>
                    <Select
                        value={ jobType || null }
                        options={ IMPORT_FORMATS() }
                        group
                        label={ i18n.jobType }
                        onChange={ (value) => this.onChangeFilter('jobType', value) }
                        data-cy='jobFormat'
                    />
                </Grid>
                <Grid size={2} sx={{ alignSelf: 'center' }}>
                    <Button
                        style={{ width: '100%' }}
                        title={i18n.search}
                        onClick={this.submit}
                    />
                </Grid>
            </Grid>
        )
    }
}

JobTableExecutionsForm.propTypes = {
    onSubmit: PropTypes.func,
    contributors: arrayOf(ContributorDto),
}

JobTableExecutionsForm.defaultProps = {
    onSubmit: () => {},
}

export default JobTableExecutionsForm